import * as angular from "angular";
import reference, { ReferenceController } from "./reference";

/** One lookup per table column supplies its display labels to all rows. */
export default angular.module("vesl.extensions.json-schema.reference-labels", [reference])
	.component("jsonSchemaReferenceLabels", {
		template: "",
		controller: ReferenceController,
		bindings: {
			schema: "<",
			ui: "<",
			contextKey: "<",
			labelStore: "<"
		}
	})
	.name;
